// src/services/dashboardService.js

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class DashboardService {
  async getDashboardStats() {
    try {
      const response = await fetch(`${API_BASE_URL}/dashboard/stats`, {
        method: "GET",
        headers: {
        'Content-Type': 'application/json',
       
        'Authorization': `Bearer ${localStorage.getItem('authToken')}`
      },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || "Failed to fetch dashboard stats");
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
      throw error;
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
